export const FETCH_NODE_LIST_SUCCESS = "FETCH_NODE_LIST_SUCCESS";
export const FETCH_NODE_LIST_REQUEST = "FETCH_NODE_LIST_REQUEST";
export const FETCH_NODE_LIST_FAILURE = "FETCH_NODE_LIST_FAILURE";
export const FETCH_NODE_LIST_UPDATE = "FETCH_NODE_LIST_UPDATE";
